import { Location } from 'history';
import {
    Box,
    Breadcrumbs,
    Button,
    Checkbox,
    Divider,
    FormControl,
    IconButton,
    InputAdornment,
    LinearProgress,
    Menu,
    MenuItem,
    OutlinedInput,
    Skeleton,
    Tab,
    Tooltip,
    Typography
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useEffect, useState } from 'react';
import { CommonLayout } from '../../commonComponents';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { GetAccountType, GetAssetClassesType, GetCategoryAverage, GetRecommendedSchemes, GetSchemeDetailsType, GetSchemeListType, GetSchemeNav, GetSchemeType, RecommendationsType, SchemeList } from '../../../redux-store/types/api-types';
import { delete_recommended_schemes, getRmDetails, getSchemeName, get_account_type, get_assest_classes, get_category_average, get_recommended_schemes, get_scheme_details, get_scheme_list, get_scheme_nav } from '../../../redux-store/actions/userManagement';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Bubble } from './investor-transaction-helper';
import { formatToIndianCurrency } from '../../../utils/utilityFunctions';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { CloseIcon, DeleteIcon } from "../../customSVGs";
import SchemeDetail from './scheme-detail';
import SearchIcon from '@mui/icons-material/Search';
import { formatDate_DDMMYYYY } from '../../../utils/date';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { Icon } from '@material-ui/core';

interface Styles {
    backgroundColor?: string;
    color?: string;
    borderRadius?: string;
    height?: string
}
export default function RecommendedSchemes({
    location
}: {
    location: Location<{ investorId: string; investorName: string }>
}): JSX.Element {

    const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };

    const dispatch = useDispatch();
    const history = useHistory();
    const currentPathname = location.pathname;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedValue, setSelectedValue] = useState(currentPathname === '/investor-transactions' ? 'Explore' : 'Suggestion');
    const [recommendationData, setRecommendationData] = useState<GetRecommendedSchemes | null>(null);
    const [isLoadingAsset, setLoadingAsset] = useState(false);
    const [isLoadingRecommendation, setLoadingRecommendation] = useState<boolean>(false);
    const [isLoadingschemeDetail, setLoadingSchemeDetail] = useState<boolean>(false);
    const [isLoadingschemeList, setLoadingSchemeList] = useState<boolean>(false);
    const [isLoadingCatAvg, setLoadingCatAvg] = useState<boolean>(false);
    const [isLoadingSchemeNav, setLoadingSchemeNav] = useState<boolean>(false);
    const [currentSchemeDetail, setCurrentSchemeDetail] = useState<RecommendationsType>();
    const [value, setValue] = useState<string>("New");
    const [checked, setChecked] = useState(false);
    const [viewSchemeDetails, setViewSchemeDetails] = useState<boolean>(false);
    const [search, setSearch] = useState<string>('');
    const [moreDetails, setMoreDetails] = useState<{ [key: number]: boolean }>({});
    const [accountType, setAccountType] = useState<GetAccountType | null>();
    const [rmId, setRmId] = useState<number | null>();

    //function to handle see more details
    const handleDetailsClick = (index: number) => {
        setMoreDetails((lessDetails) => {
            const updatedDetails = { ...lessDetails, [index]: !lessDetails[index] };
            return updatedDetails;
        });
    };

    //function to handle change of menu - Explore/recommendation
    const handleMenuItemClick = (value: any) => {
        if (value === 'Explore') history.push('/investor-transactions', {
            investorId: investorId,
            investorName: investorName,
        });
        else if (value === 'Suggestion') history.push('/recommended-schemes', {
            investorId: investorId,
            investorName: investorName,
        });
        else if (value === 'Holdings') history.push('/holdings', {
            investorId: investorId,
            investorName: investorName,
        });
        // else if (value === 'Orders') history.push('/orders', {
        //     investorId: investorId,
        //     investorName: investorName,
        // });
        setSelectedValue(value);
        handleClose();
    };

    //api call for get_recommended_schemes
    useEffect(() => {

        let isComponentActive = true;
        setRecommendationData(null);
        (async function () {
            try {
                setLoadingRecommendation(true);
                const response = (await dispatch(
                    get_recommended_schemes({

                        ClientCode: investorId
                    })
                )) as unknown as GetRecommendedSchemes;
                if (!isComponentActive) {
                    return;
                }

                setRecommendationData(response);

                setLoadingRecommendation(false);
            } catch (e) {
                setLoadingRecommendation(false);
                console.log((e as Error).message);
            }
        })();

        return () => {
            isComponentActive = false;
        };

    }, [dispatch]);

    //api call for getting rmid
    useEffect(() => {

        let isComponentActive = true;
        setRmId(null);
        (async function () {
            try {
                const response = (await dispatch(
                    getRmDetails()
                )) as unknown as any;
                if (!isComponentActive) {
                    return;
                }
                setRmId(response.Header_ID);

            } catch (e) {
                console.log((e as Error).message);
            }
        })();

        return () => {
            isComponentActive = false;
        };
    }, [])
    //api call for account type and name matching
    useEffect(() => {

        let isComponentActive = true;
        setAccountType(null);
        (async function () {
            try {
                const response = (await dispatch(
                    get_account_type({
                        rmID: rmId,
                        ClientCode: investorId
                    })
                )) as unknown as GetAccountType;
                if (!isComponentActive) {
                    return;
                }
                setAccountType(response);
            } catch (e) {
                console.log((e as Error).message);
            }
        })();

        return () => {
            isComponentActive = false;
        };
    }, [])

    const breadcrumbs = [
        <Typography key="1" sx={{ color: '#BBB5B5 !important' }}>
            Total Investors
        </Typography>,
        <Typography key="2" sx={{ color: '#BBB5B5 !important' }}>
            {investorName}
        </Typography>,
        <Typography key="3" color="text.primary">
            Suggestions
        </Typography>,
    ];

    //function to handle change of asset class tabs
    const handleChange = (event: any, value: any) => {
        setValue(value);
    };

    const open = Boolean(anchorEl);
    const handleClick_ = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function roundToTwo(num: number) {
        const num2 = num + "e+2";

        return +(Math.round(Number(num2)) + "e-2");
    }
    const Nanprocessor = function (entry: any) {
        if (entry) {
            return entry;
        } else {
            return 0;
        }
    };

    const handleCheckboxChange = () => {
        setChecked(!checked);
    };

    //function to enable showing scheme detail screen
    const handleSetViewSchemeDetails = async (val: boolean, schemeDetail: SchemeList | RecommendationsType | undefined | null) => {
        setCurrentSchemeDetail(schemeDetail as RecommendationsType);
        // const response = await getSchemeDetails(schemeDetail as RecommendationsType);
        // const requiredScheme = response?.sub_asset_classes.filter((item: SchemeList) => item.SchemeID == schemeDetail?.SchemeID);
        // requiredScheme ? setSelectedScheme(requiredScheme[0]) : null;
        setViewSchemeDetails(val);
    };

    const handleDeleteSchemes = async () => {
        const data: any = [];
        // const a = 5;
        const b = 'O000906';
        // const c = 18;
        const obj = {
            "rmID": 5,
            "ClientCode": b,
            "RecID": 18
        }
        data.push(obj);

        const recommendationData = {
            recommendation_data: data
        }
        await discardrecommendedschemes(recommendationData);
    }

    async function discardrecommendedschemes(data: any) {
        let isComponentActive = true;
        (async function () {
            try {
                // setIsLoading(true);
                const response = (await dispatch(
                    delete_recommended_schemes(data)
                )) as unknown as any;
                alert("data deleted successfully" + response)
                // if (!isComponentActive) {
                //   return;
                // }
                // setIsLoading(false);
                // getRedeemValidations();

                // setRecommended(true);

            } catch (e) {
                console.log((e as Error).message);
                // setIsLoading(false);
            }
        })();

        return () => {
            isComponentActive = false;
        };
    }

    const handleCloseSchemeDetails = () => {
        setViewSchemeDetails(false);
    };

    const [schemeDetail, setSchemeDetail] = useState<GetSchemeDetailsType | null>(null);
    //api call for get_scheme_details
    useEffect(() => {
        if (currentSchemeDetail) {
            const scheme_id = currentSchemeDetail.SchemeID;
            let isComponentActive = true;
            setSchemeDetail(null);
            (async function () {
                try {
                    setLoadingSchemeDetail(true);
                    const response = (await dispatch(
                        get_scheme_details(scheme_id)
                    )) as unknown as GetSchemeDetailsType;
                    if (!isComponentActive) {
                        return;
                    }

                    setSchemeDetail(response);
                    setLoadingSchemeDetail(false);
                } catch (e) {
                    setLoadingSchemeDetail(false);
                    console.log((e as Error).message);
                }
            })();

            return () => {
                isComponentActive = false;
            };
        }

    }, [dispatch, currentSchemeDetail]);

    const [categoryAverage, setCategoryAverage] = useState<GetCategoryAverage | null>(null);
    //api call for get_category_avg
    useEffect(() => {
        if (currentSchemeDetail) {
            const payload = {
                marketValue: false,
                schemaId: currentSchemeDetail.SchemeID
            }
            let isComponentActive = true;
            setCategoryAverage(null);
            (async function () {
                try {
                    setLoadingCatAvg(true);
                    const response = (await dispatch(
                        get_category_average(payload)
                    )) as unknown as GetCategoryAverage;
                    if (!isComponentActive) {
                        return;
                    }
                    setCategoryAverage(response);
                    setLoadingCatAvg(false);
                } catch (e) {
                    setLoadingCatAvg(false);
                    console.log((e as Error).message);
                }
            })();

            return () => {
                isComponentActive = false;
            };
        }

    }, [dispatch, currentSchemeDetail]);

    const [schemeNav, setSchemeNav] = useState<GetSchemeNav | null>(null);
    //api call for get_scheme_nav
    useEffect(() => {
        if (currentSchemeDetail) {
            const schemeId = currentSchemeDetail.SchemeID;
            let isComponentActive = true;
            setSchemeNav(null);
            (async function () {
                try {
                    setLoadingSchemeNav(true);
                    const response = (await dispatch(
                        get_scheme_nav(schemeId)
                    )) as unknown as GetSchemeNav;
                    if (!isComponentActive) {
                        return;
                    }
                    setSchemeNav(response);
                    setLoadingSchemeNav(false);
                } catch (e) {
                    setLoadingSchemeNav(false);
                    console.log((e as Error).message);
                }
            })();

            return () => {
                isComponentActive = false;
            };
        }

    }, [dispatch, currentSchemeDetail]);

    const filteredRecommendations = recommendationData?.recommendedSchemes[0]?.filter((item) =>
        Object.values(item).some((value) => String(value).toLowerCase().includes(search.toLowerCase()))
    );
    const tabMap = [
        {
            label: "New Purchase",
            value: "New",
            trType: "New",
            trType2: "ISIP"
        },
        {
            label: "Additional Purchase",
            value: "Add",
            trType: "Add",
            trType2: "XSIP",
        },
        {
            label: "STP",
            value: "STP",
            trType: "STP",

        },
        {
            label: "SWP",
            value: "SWP",
            trType: "SWP",

        },
        {
            label: "Switch",
            value: "Swt",
            trType: "Swt",

        },
        {
            label: "Redemption",
            value: "Red",
            trType: "Red",

        }
    ]

    const [subVal, setSubVal] = useState<string>('lumpsum');
    const [selectedValuesSIP, setselectedValuesSIP] = useState<any>([]);
    const [selectedValuesLump, setselectedValuesLump] = useState<any>([]);
    const handleValChange = (event: any, value: any) => {
        setselectedValuesSIP([]);
        setselectedValuesLump([]);
        setSubVal('lumpsum');
        setValue(value);
    };
    const handleSubValChange = (event: any, val: any) => {
        setselectedValuesSIP([]);
        setselectedValuesLump([]);
        setSubVal(val);
    }


    // const getBackgroundColor = (ele: any) => {
    //     const daysLeft = 7 - ele.NoOfDays;
    //     if (daysLeft >= 5) {
    //         return { backgroundColor: 'green' };
    //     } else if (daysLeft >= 3) {
    //         return { backgroundColor: 'yellow' };
    //     } else {
    //         return { backgroundColor: 'red' };
    //     }
    // };

    const getStyles = (ele: any): Styles => {
        const styles: Styles = {}; // Start with an empty styles object
        const daysLeft = 7 - ele.NoOfDays;
        // Add background color based on the number of days left
        if (daysLeft >= 5) {
            styles.backgroundColor = '#52AC8C';
        } else if (daysLeft >= 3) {
            styles.backgroundColor = '#EA8B24';
        } else {
            styles.backgroundColor = '#EB4646';
        }
        styles.color = 'white';
        styles.borderRadius = '15px';
        styles.height = '20px'
        return styles;
    };
    const getStatusStyles = (ele: any): Styles => {
        const styles: Styles = {}; // Start with an empty styles object
        if (ele.Expirystatus === "Active") {
            styles.color = '#52AC8C'
        } else if (ele.Expirystatus === "Expired") {
            styles.color = 'grey'
        } else if (ele.Expirystatus === "In Cart") {
            styles.color = '#EA8B24'
        } else if (ele.Expirystatus === "Order confirmed_Success") {
            styles.color = '#337FC9'
        } else if (ele.Expirystatus === "Order confirmed_Failed") {
            styles.color = '#EB4646'
        } else { styles.color = '#337FC9' }

        return styles;
    };


    return (
        <div>

            <CommonLayout>
                <>
                    {location.pathname === "/investor-transactions" || location.pathname === "/recommended-schemes" || location.pathname === "/holdings" || location.pathname === "/orders" ?
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-end', mb: 2 }}>
                            <Button
                                sx={{ border: "1.5px solid #4B81B1", height: '40px', color: '#4B81B1', fontWeight: 400, fontSize: '15px' }}
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick_}
                            >
                                {selectedValue}
                                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={() => handleMenuItemClick('Explore')}>Explore</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClick('Suggestion')}>Suggestions</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClick('Holdings')}>Holdings</MenuItem>
                                {/* <MenuItem onClick={() => handleMenuItemClick('Orders')}>Orders</MenuItem> */}
                            </Menu>
                        </Box> : <></>}

                    {/* Section above main card for Breadcrumbs */}
                    <Box
                        sx={{
                            background: '#EEF9F4',
                            borderRadius: '16px',
                            px: 3,
                            py: 1.5,
                            mb: 2.5,
                        }}>
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            aria-label="breadcrumb"
                            sx={{
                                '& .MuiTypography-root': {
                                    fontSize: 20,
                                    lineHeight: '23px',
                                    fontWeight: 500,
                                    color: '#BBB5B5',
                                    '&.MuiTypography-body1': { color: '#22242C' },
                                },
                                '& .MuiBreadcrumbs-separator': {
                                    '& .MuiSvgIcon-root': { color: 'rgba(0,0,0,0.6)' },
                                    '&:last-of-type': {
                                        background: 'red',
                                        '& .MuiSvgIcon-root': { color: '#22242C' },
                                    },
                                },
                            }}>
                            {breadcrumbs}
                        </Breadcrumbs>
                    </Box>
                    {(isLoadingAsset || isLoadingschemeDetail || isLoadingCatAvg || isLoadingSchemeNav || isLoadingRecommendation || isLoadingschemeList) ? (
                        <LinearProgress sx={{ mt: 2.5 }} />
                    ) :
                        (<Box
                            sx={{
                                bgcolor: 'common.white',
                                boxShadow: '0px 4px 28px 2px rgba(0, 0, 0, 0.08)',
                                borderRadius: '5px',
                                py: 2,
                            }}>

                            {/* Displays recommendation list / scheme detail */}
                            {viewSchemeDetails ?
                                //scheme detail
                                <div>
                                    <SchemeDetail
                                        handleBackClick={() => setViewSchemeDetails(false)}
                                        handleSetViewSchemeDetails={handleSetViewSchemeDetails}
                                        investorId={investorId}
                                        schemeDetail={schemeDetail?.scheme_details}
                                        schemeData={currentSchemeDetail as unknown as SchemeList}
                                        categoryAverage={categoryAverage?.category_averages}
                                        schemeNav={schemeNav?.scheme_nav}
                                    />
                                </div>
                                :
                                //Recommendation List
                                <Box>
                                    <FormControl sx={{ width: 225, mx: 2 }} variant="outlined">
                                        <OutlinedInput
                                            value={search}
                                            onChange={({ target: { value } }) => {
                                                setSearch(value);
                                            }}
                                            sx={{ '& .MuiOutlinedInput-input': { py: 1, fontSize: 13 } }}
                                            id="search-field"
                                            placeholder="Search by AMC Name"
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                    {isLoadingAsset ? <Skeleton /> :
                                        <TabContext value={value} >
                                            <Box sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                width: '100%',
                                                '& .MuiTabPanel-root': { px: 0 },
                                                '& .MuiTab-root': {
                                                    color: '#A1A2A2',
                                                    opacity: 0.8,
                                                    fontSize: 17,
                                                    lineHeight: '24px',
                                                    textTransform: 'capitalize',
                                                    px: { xs: 1, md: 2, lg: 3 },
                                                    mx: 2,
                                                    '&.Mui-selected': {
                                                        color: '#4B81B1',
                                                    },
                                                },
                                                '& .MuiTabs-indicator': {
                                                    height: 3,
                                                    background: '#4B81B1',
                                                },
                                            }}>
                                                <TabList onChange={handleChange}>

                                                    {tabMap.map((val: any, index: number) => {
                                                        return (
                                                            <Tab label={val.label} value={val.value} key={index} />
                                                        )
                                                    })}
                                                </TabList>
                                                {/* <Button variant="contained">Edit</Button> */}
                                            </Box>
                                            <Divider />
                                            <Box sx={{ px: 3 }}>
                                                {tabMap.map((val) =>

                                                    <TabPanel value={val.value} key={val.value}>
                                                        {val.value == "New" || val.value == "Add" ?
                                                            //Tab for New and Additional purchase
                                                            <>
                                                                <TabContext value={subVal}>
                                                                    <Box
                                                                        sx={{

                                                                            width: '100%',
                                                                            '& .MuiTabPanel-root': { px: 0 },
                                                                            '& .MuiTab-root': {
                                                                                color: '#A1A2A2',
                                                                                opacity: 0.8,
                                                                                fontSize: 13,

                                                                                textTransform: 'capitalize',
                                                                                px: { xs: 1, md: 2, lg: 3 },
                                                                                my: 0,
                                                                                py: 0,
                                                                                '&.Mui-selected': {
                                                                                    color: '#4B81B1',
                                                                                },
                                                                            },
                                                                            '& .MuiTabs-indicator': {
                                                                                height: 2,
                                                                                background: '#4B81B1',
                                                                            },
                                                                        }}>
                                                                        <TabList
                                                                            onChange={handleSubValChange}
                                                                            aria-label="product tabs"
                                                                            variant="scrollable"
                                                                            scrollButtons="auto"
                                                                        >
                                                                            {[{ label: "SIP", value: "sip" }, { label: "Lumpsum", value: "lumpsum" }].map((val_: any, index: number) => {
                                                                                return (
                                                                                    <Tab label={val_.label} value={val_.value} key={index} />
                                                                                )
                                                                            })}
                                                                        </TabList>
                                                                    </Box>
                                                                    <Divider />
                                                                    <Box>
                                                                        {[{ label: "SIP", value: "sip" }, { label: "Lumpsum", value: "lumpsum" }].map((val_) => {
                                                                            return (
                                                                                <TabPanel value={val_.value} key={val_.value}>

                                                                                    {recommendationData?.recommendedSchemes[0].filter((i: any) => {
                                                                                        return (i.SchemeType == val.trType || i.SchemeType == val.trType2)
                                                                                    }).length === 0 ?
                                                                                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                                            <Typography sx={{ color: "lightgrey", fontSize: 18, fontWeight: 500 }}>No schemes Recommended</Typography>
                                                                                        </Box>
                                                                                        :
                                                                                        <>
                                                                                            {filteredRecommendations?.filter((i: any) => {
                                                                                                return (val_.value == 'sip' ? i.SchemeType === val.trType2 : i.SchemeType == val.trType)
                                                                                            }).map((ele: RecommendationsType, index: number) => {
                                                                                                return <div
                                                                                                    key={index}
                                                                                                >

                                                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', my: 2.5 }}>
                                                                                                        {/* <Box sx={{ width: '10%' }}>
                                                            <Checkbox sx={{ color: '#337FC9', mx: 1.5 }}
                                                                onChange={handleCheckboxChange} checked={checked}
                                                            />
                                                        </Box> */}
                                                                                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: "35%" }}>
                                                                                                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                                                                                                <Box sx={{ width: '70%' }}><Typography sx={{ fontSize: 12, fontWeight: 500, mb: 0.5 }}>
                                                                                                                    {ele.SchemeName}
                                                                                                                </Typography>
                                                                                                                </Box>
                                                                                                                {ele.Expirystatus === "Active" ?
                                                                                                                    <Box sx={getStyles(ele)}>
                                                                                                                        {(`${7 - Number(ele.NoOfDays)}`) === '1' ?
                                                                                                                            <Typography sx={{ fontSize: '9px', fontWeight: '0', p: 0.5 }} >{`${7 - Number(ele.NoOfDays)} day left`}</Typography>
                                                                                                                            : <Typography sx={{ fontSize: '9px', fontWeight: '0', p: 0.5 }} >{`${7 - Number(ele.NoOfDays)} days left`}</Typography>
                                                                                                                        }
                                                                                                                    </Box> : ''
                                                                                                                }
                                                                                                            </Box>
                                                                                                            <Box sx={{ display: 'flex', flexWrap: "wrap" }}>
                                                                                                                {!!ele.AssetClassName && (
                                                                                                                    <Bubble text={ele.AssetClassName} />
                                                                                                                )}
                                                                                                                {!!ele.Sub_AssetclassName && (
                                                                                                                    <Bubble text={ele.Sub_AssetclassName} />
                                                                                                                )}

                                                                                                                {ele.PlanName.length !== 0 && <Bubble text={ele.PlanName} />}

                                                                                                            </Box>
                                                                                                        </Box>

                                                                                                        <Box sx={{ width: "10%" }}>
                                                                                                            <Typography sx={{ fontSize: 12, color: '#5a7c82', display: 'flex', alignItems: 'flex-start' }}>Status</Typography>
                                                                                                            {ele.Expirystatus === "Order confirmed_Success" || ele.Expirystatus === "Order confirmed_Failed" || ele.Expirystatus === "Order confirmed_Payment Successfully Completed" ? <Box sx={getStatusStyles(ele)}><Typography sx={{ fontSize: 12, fontWeight: '500' }}>
                                                                                                                {(ele.Expirystatus).split('_').join(': ').replace(/(\w+)/g, match => match.charAt(0).toUpperCase() + match.slice(1))}
                                                                                                            </Typography>
                                                                                                            </Box> : <Box sx={getStatusStyles(ele)}><Typography sx={{ fontSize: 12, fontWeight: '500' }}>
                                                                                                                {ele.Expirystatus}
                                                                                                            </Typography>
                                                                                                            </Box>}
                                                                                                        </Box>
                                                                                                        <Box sx={{ width: "16%" }}>
                                                                                                            <Typography sx={{ fontSize: 12, color: '#5a7c82', display: 'flex', alignItems: 'flex-start' }}>Recommended Amount</Typography>
                                                                                                            <Typography sx={{ fontSize: 12 }}>
                                                                                                                {ele.InvestmentAmount === 0 || !ele.InvestmentAmount
                                                                                                                    ? "NA"
                                                                                                                    : formatToIndianCurrency(ele.InvestmentAmount, 1)}
                                                                                                            </Typography>
                                                                                                        </Box>

                                                                                                        <Box sx={{ width: "6%", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                                                            <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Returns</Typography>
                                                                                                            <Typography sx={{ fontSize: 12, color: "rgb(30, 163, 98)" }}>
                                                                                                                {Nanprocessor(roundToTwo(Number(ele.Sch_Return5Yr)))} %
                                                                                                            </Typography>
                                                                                                        </Box>

                                                                                                        <Box sx={{ width: '6%' }}>
                                                                                                            <ArrowForwardIosIcon
                                                                                                                onClick={() => handleSetViewSchemeDetails(true, ele)}
                                                                                                                sx={{ borderRadius: 1, backgroundColor: '#337FC9', color: '#ffffff', p: 0.2, mx: 1.5, cursor: 'pointer' }} />
                                                                                                        </Box>

                                                                                                    </Box>
                                                                                                    {/* <Divider /> */}
                                                                                                    {moreDetails[index] ?
                                                                                                        <>
                                                                                                            {ele.SchemeType === "ISIP" || ele.SchemeType === "XSIP" ?

                                                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', my: 3, justifyContent: 'space-between' }}>
                                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Frequency </Typography>
                                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600', alignContent: 'flex-start' }}> {ele.Frequency}</Typography>
                                                                                                                    </Box>
                                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>No. Of Instalments </Typography>
                                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {ele.No_of_Installments}</Typography>
                                                                                                                    </Box>
                                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Recommendation Date </Typography>
                                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {formatDate_DDMMYYYY(ele.EntryDate?.split('T')[0])}</Typography>
                                                                                                                    </Box>
                                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>SIP Date </Typography>
                                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {formatDate_DDMMYYYY(ele.SIP_date?.split('T')[0])}</Typography>
                                                                                                                    </Box>
                                                                                                                    {ele.Folio === '' ?
                                                                                                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                                            <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Account Type </Typography>
                                                                                                                            {accountType?.account_type[0].filter((i: any) => i.AccountId === ele.accountID)
                                                                                                                                .map((item: any) => (
                                                                                                                                    <Typography key={item.AccountId} sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}>
                                                                                                                                        {item.AccountType}
                                                                                                                                    </Typography>
                                                                                                                                ))}
                                                                                                                        </Box> :
                                                                                                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                                            <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Folio </Typography>
                                                                                                                            <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {ele.Folio}</Typography>
                                                                                                                        </Box>
                                                                                                                    }

                                                                                                                </Box>
                                                                                                                : <Box sx={{ display: 'flex', flexDirection: 'row', my: 3 }}>
                                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '33%' }}>
                                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Recommendation Date </Typography>
                                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {formatDate_DDMMYYYY(ele.EntryDate?.split('T')[0])}</Typography>
                                                                                                                    </Box>
                                                                                                                    {ele.Folio === '' ?
                                                                                                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '40%' }}>
                                                                                                                            <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Account Type </Typography>
                                                                                                                            {accountType?.account_type[0].filter((i: any) => i.AccountId === ele.accountID)
                                                                                                                                .map((item: any) => (
                                                                                                                                    <Typography key={item.AccountId} sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}>
                                                                                                                                        {item.AccountType}
                                                                                                                                    </Typography>
                                                                                                                                ))}
                                                                                                                        </Box> :
                                                                                                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '30%' }}>
                                                                                                                            <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Folio </Typography>
                                                                                                                            <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {ele.Folio}</Typography>
                                                                                                                        </Box>
                                                                                                                    }
                                                                                                                </Box>


                                                                                                            }
                                                                                                        </>
                                                                                                        : ''}
                                                                                                    <Box sx={{ backgroundColor: '#C7E1FF', height: '12px', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', fontSize: '10px' }} >
                                                                                                        <IconButton onClick={() => handleDetailsClick(index)}>
                                                                                                            {
                                                                                                                moreDetails[index] ? <KeyboardDoubleArrowUpIcon sx={{ fontSize: '15px', color: '#337FC9' }} /> : <KeyboardDoubleArrowDownIcon sx={{ fontSize: '15px', color: '#337FC9' }} />
                                                                                                            }
                                                                                                        </IconButton>
                                                                                                    </Box>
                                                                                                </div>
                                                                                            })}

                                                                                        </>
                                                                                    }
                                                                                </TabPanel>
                                                                            )
                                                                        })}
                                                                    </Box>
                                                                </TabContext>
                                                            </> :
                                                            //Tab for STP, SWP, Switch and redemption
                                                            <Box>
                                                                {recommendationData?.recommendedSchemes[0].filter((i: any) => {
                                                                    return (i.SchemeType === val.trType || i.SchemeType == val.trType2)
                                                                }).length === 0 ?
                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                        <Typography sx={{ color: "lightgrey", fontSize: 18, fontWeight: 500 }}>No schemes Recommended</Typography>
                                                                    </Box>
                                                                    :
                                                                    <>
                                                                        {filteredRecommendations?.filter((i: any) => {
                                                                            return (i.SchemeType === val.trType)
                                                                        }).map((ele: RecommendationsType, index: number) => {
                                                                            return <div
                                                                                key={index}

                                                                            >

                                                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', my: 2.5 }}>
                                                                                    {/* <Box sx={{ width: '10%' }}>
                                                    <Checkbox sx={{ color: '#337FC9', mx: 1.5 }}
                                                        onChange={handleCheckboxChange} checked={checked}
                                                    />
                                                </Box> */}
                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: "40%" }}>
                                                                                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                                                                            <Box sx={{ width: '70%' }}><Typography sx={{ fontSize: 12, fontWeight: 500, mb: 0.5 }}>
                                                                                                {ele.SchemeName}
                                                                                            </Typography>
                                                                                            </Box>
                                                                                            {ele.Expirystatus === "Active" ?
                                                                                                <Box sx={getStyles(ele)}>
                                                                                                    {(`${7 - Number(ele.NoOfDays)}`) === '1' ?
                                                                                                        <Typography sx={{ fontSize: '9px', fontWeight: '0', p: 0.5 }} >{`${7 - Number(ele.NoOfDays)} day left`}</Typography>
                                                                                                        : <Typography sx={{ fontSize: '9px', fontWeight: '0', p: 0.5 }} >{`${7 - Number(ele.NoOfDays)} days left`}</Typography>
                                                                                                    }
                                                                                                </Box> : ''
                                                                                            }
                                                                                        </Box>
                                                                                        <Box sx={{ display: 'flex', flexWrap: "wrap" }}>
                                                                                            {!!ele.AssetClassName && (
                                                                                                <Bubble text={ele.AssetClassName} />
                                                                                            )}
                                                                                            {!!ele.Sub_AssetclassName && (
                                                                                                <Bubble text={ele.Sub_AssetclassName} />
                                                                                            )}

                                                                                            {ele.PlanName.length !== 0 && <Bubble text={ele.PlanName} />}

                                                                                        </Box>
                                                                                    </Box>
                                                                                    <Box sx={{ width: "12%" }}>
                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', display: 'flex', alignItems: 'center' }}>Status</Typography>
                                                                                        {ele.Expirystatus === "Order confirmed_Success" || ele.Expirystatus === "Order confirmed_Failed" || ele.Expirystatus === "Order confirmed_Payment Successfully Completed" ? <Box sx={getStatusStyles(ele)}><Typography sx={{ fontSize: 12, fontWeight: '500' }}>
                                                                                            {(ele.Expirystatus).split('_').join(': ').replace(/(\w+)/g, match => match.charAt(0).toUpperCase() + match.slice(1))}
                                                                                        </Typography>
                                                                                        </Box> : <Box sx={getStatusStyles(ele)}><Typography sx={{ fontSize: 12, fontWeight: '500' }}>
                                                                                            {ele.Expirystatus}
                                                                                        </Typography>
                                                                                        </Box>}
                                                                                    </Box>
                                                                                    <Box sx={{ width: "16%" }}>
                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', display: 'flex', alignItems: 'flex-start' }}>Recommended Amount</Typography>
                                                                                        <Typography sx={{ fontSize: 12 }}>
                                                                                            {ele.InvestmentAmount === 0 || !ele.InvestmentAmount
                                                                                                ? "NA"
                                                                                                : formatToIndianCurrency(ele.InvestmentAmount, 1)}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                    {ele.SchemeType == "Swt" || ele.SchemeType == "STP" ?
                                                                                        <Box sx={{ width: "22%" }}>
                                                                                            <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>To Scheme</Typography>
                                                                                            <Typography sx={{ fontSize: 12 }}>
                                                                                                {ele.ToschemeName}
                                                                                            </Typography>
                                                                                        </Box>
                                                                                        : ""}


                                                                                    <Box sx={{ width: "6%", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Returns</Typography>
                                                                                        <Typography sx={{ fontSize: 12, color: "rgb(30, 163, 98)" }}>
                                                                                            {Nanprocessor(roundToTwo(Number(ele.Sch_Return5Yr)))} %
                                                                                        </Typography>
                                                                                    </Box>


                                                                                    <Box sx={{ width: '6%' }}>
                                                                                        <ArrowForwardIosIcon
                                                                                            onClick={() => handleSetViewSchemeDetails(true, ele)}
                                                                                            sx={{ borderRadius: 1, backgroundColor: '#337FC9', color: '#ffffff', p: 0.2, mx: 1.5, cursor: 'pointer' }} />
                                                                                    </Box>

                                                                                </Box>
                                                                                {/* <Divider /> */}
                                                                                {moreDetails[index] ?
                                                                                    <>
                                                                                        {ele.SchemeType === "Red" ?
                                                                                            <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', my: 3 }}>
                                                                                                <Box sx={{ display: 'flex', flexDirection: 'column', width: '33%' }}>
                                                                                                    <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Redemption Type </Typography>
                                                                                                    <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600', }}>Partial</Typography>
                                                                                                </Box>
                                                                                                <Box sx={{ display: 'flex', flexDirection: 'column', width: '33%' }}>
                                                                                                    <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Recommendation Date </Typography>
                                                                                                    <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {formatDate_DDMMYYYY(ele.EntryDate?.split('T')[0])}</Typography>
                                                                                                </Box>
                                                                                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                                                                    <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Folio </Typography>
                                                                                                    <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {ele.Folio}</Typography>
                                                                                                </Box>
                                                                                            </Box>
                                                                                            : ele.SchemeType === "Swt" ?
                                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', mb: 3 }}>
                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '33%', justifyContent: 'flex-start' }}>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Switch Type </Typography>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600', }}>Partial</Typography>
                                                                                                    </Box>
                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '33%' }}>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Recommendation Date </Typography>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {formatDate_DDMMYYYY(ele.EntryDate?.split('T')[0])}</Typography>
                                                                                                    </Box>
                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', }}>Folio </Typography>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {ele.Folio}</Typography>
                                                                                                    </Box>
                                                                                                </Box>
                                                                                                :

                                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', mb: 3, justifyContent: 'space-between' }}>
                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Frequency </Typography>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600', alignContent: 'flex-start' }}> {ele.Frequency}</Typography>
                                                                                                    </Box>
                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>No. Of Instalments </Typography>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {ele.No_of_Installments}</Typography>
                                                                                                    </Box>
                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Recommendation Date </Typography>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {formatDate_DDMMYYYY(ele.EntryDate?.split('T')[0])}</Typography>
                                                                                                    </Box>
                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>{value} Date </Typography>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {formatDate_DDMMYYYY(ele.SIP_date?.split('T')[0])}</Typography>
                                                                                                    </Box>
                                                                                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '20%' }}>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82' }}>Folio </Typography>
                                                                                                        <Typography sx={{ fontSize: 12, color: '#5a7c82', fontWeight: '600' }}> {ele.Folio}</Typography>
                                                                                                    </Box>
                                                                                                </Box>



                                                                                        }
                                                                                    </>
                                                                                    : ''}
                                                                                <Box sx={{ backgroundColor: '#C7E1FF', height: '12px', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', fontSize: '10px' }} >
                                                                                    <IconButton onClick={() => handleDetailsClick(index)}>
                                                                                        {
                                                                                            moreDetails[index] ? <KeyboardDoubleArrowUpIcon sx={{ fontSize: '15px', color: '#337FC9' }} /> : <KeyboardDoubleArrowDownIcon sx={{ fontSize: '15px', color: '#337FC9' }} />
                                                                                        }
                                                                                    </IconButton>
                                                                                </Box>

                                                                            </div>
                                                                        })}
                                                                    </>
                                                                }

                                                            </Box>}

                                                    </TabPanel>

                                                )}

                                            </Box>

                                        </TabContext>}
                                </Box>
                            }

                        </Box>)
                    }

                </>

            </CommonLayout>

        </div >
    );
}
